export default __webpack_public_path__ + "media/video_thumbnail2.45f5c70f.png";